import { render, staticRenderFns } from "./TaskDashboard.vue?vue&type=template&id=71d593ee&scoped=true&"
import script from "./TaskDashboard.vue?vue&type=script&lang=js&"
export * from "./TaskDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TaskDashboard.vue?vue&type=style&index=0&id=71d593ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d593ee",
  null
  
)

export default component.exports